export const getSupplierSetupTableColumns=()=>{

    return [
        {
            headerName: "Supplier", field: "supplier", width: 150
        },
        {
            headerName: "Supplier Description", field: "supplier_name", width: 150
        },
        {
            headerName: "EDI Unit", field: "unit", width: 75
        },
        {
            headerName: "Unit", field: "unit_key", width: 75
        },
        {
            headerName: "Unit Name", field: "unit_name", width: 200
        },
        {
            headerName: "EDI Type", field: "supplier_type", width: 150
        },
        {
            headerName: "SAP Number", field: "sap_partner_number", width: 150
        },
        {
            headerName: "Transaction", field: "transaction", width: 200
        },
        {
            headerName: "Version", field: "version", width: 125
        },
        {
            headerName: "Direction", field: "direction", width: 125
        },
        {
            headerName: "T/P Flag", field: "tp_flag", width: 75
        },
        {
            headerName: "ISA Qualifier", field: "isa_qualifier", width: 100
        },
        {
            headerName: "ISA ID", field: "isa_id", width: 200
        },
        {
            headerName: "GS ID", field: "gs_id", width: 200
        },
        {
            headerName: "Last ISA Date", field: "last_isa_date", width: 100
        },
        {
            headerName: "Last ISA Cntl #", field: "last_isa_cntrlnum", width: 150
        },

        {
            headerName: "Last GS Date", field: "last_gs_date", width: 150
        },

        {
            headerName: "Last GS Cntl", field: "last_grp_cntrlnum", width: 150
        },
        {
            headerName: "Last Tran Cntl", field: "last_tran_cntrlnum", width: 150
        },
        {
            headerName: "Envelope", field: "envelope", minWidth: 350, flex: 1
        },

    ];
}
